import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";
import {connect} from "react-redux";
import RevenueReport from './revenue-report';

import {
  getLeasables,
  removeImage,
  updateLeasingDescription,
  updateLeasingDescriptionFail,
  uploadImage
} from '../../appRedux/actions';
import LeasingReport from "./report";
import LeasingCalculation from "./calculation";

class Leasing extends Component {

  state = {
    leasableAssets: [],
    pageTitle: '',
  }

  fetchResources = (filters) => {
    this.props.getLeasables(filters);
  }

  updateLeaseInfoHandler = (assetId, description, date) => {
    const payload = {
      assetId, description, date
    };
    this.props.updateLeasingDescription(payload);
  }

  uploadImageHandler = (asset, file) => {
    this.props.uploadImage({assetId: asset, file});
  }

  removeImageHandler = (asset, doc) => {
    this.props.removeImage(asset, doc);
  }

  setPageTitle = (title) => {
    this.setState({
      pageTitle: title
    })
  }

  render() {
    const {match, data, updatedLeaseInfo, resource, edit, fetchResource, loading, filters, modules, authUser, resourceName} = this.props;
    const {columns, visibleColumns} = this.state;

    return (
      <div>
        <h2>{this.state.pageTitle ? this.state.pageTitle : resourceName}</h2>
        <Switch>
          <Route path={`${match.url}`} exact
                 render={() => <LeasingReport columns={columns}
                                              datas={data}
                                              loading={loading}
                                              updatedLeaseInfo={updatedLeaseInfo}
                                              updateLeasingInfo={this.updateLeaseInfoHandler}
                                              fetchResources={this.fetchResources}
                                              title={resourceName}
                                              size={'middle'}
                                              authUser={authUser}
                                              uploadPhoto={this.uploadImageHandler}
                                              uploadedPhoto={this.props.uploadedPhoto}
                                              removePhoto={this.removeImageHandler}
                                              isPhotoRemoved={this.props.isImageRemoved}
                                              {...this.props}
                 />
                 }/>

          <Route path={`${match.url}/revenue-report`} exact
                 render={() => <RevenueReport setPageTitle={this.setPageTitle} {...this.props}/>
                 }/>
          <Route path={`${match.url}/calculation`} exact
                 render={() => <LeasingCalculation
                   // columns={columns}
                   // datas={[]}
                   setPageTitle={this.setPageTitle}
                   loading={loading}
                   // updatedLeaseInfo={updatedLeaseInfo}
                   // updateLeasingInfo={this.updateLeaseInfoHandler}
                   // fetchResources={this.fetchResources}
                   title={resourceName}
                   size={'middle'}
                   authUser={authUser}
                   // uploadPhoto={this.uploadImageHandler}
                   // uploadedPhoto={this.props.uploadedPhoto}
                   // removePhoto={this.removeImageHandler}
                   // isPhotoRemoved={this.props.isImageRemoved}
                   {...this.props}
                 />
                 }/>
        </Switch>
      </div>
    );
  }
}


const mapStateToProps = ({auth, leasing, commonData}) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    // total: leasing.total,
    updatedLeaseInfo: leasing.leaseInfo,
    data: leasing.resources,
    uploadedPhoto: leasing.uploadData,
    isImageRemoved: leasing.removeData,
  }
};

function mapDispatchToProps(dispatch) {
  return {
    getLeasables,
    updateLeasingDescription,
    updateLeasingDescriptionFail,
    uploadImage,
    removeImage
  };
}

export default connect(mapStateToProps, mapDispatchToProps())(Leasing);
